import { FC, useCallback, useContext, useEffect, useState } from 'react';

import { SettingsBlock } from 'components';
import { LocalizationContext } from 'localization';
import notification from 'services/notificationService';
import {
  CUSTOMIZATION_DEFAULT_DATA,
  ESettingsAliases,
  SettingsContext,
} from 'settings';

import {
  CurrentColors,
  PreviewBlock,
  ShellBackground,
  ShellIcon,
} from './compnents';
import s from './CustomizationShell.module.scss';

export const CustomizationShell: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: {
        shellBgSkin,
        shellSkinLogo,
        shellSkinAccentColor,
        shellSkinAdditionalColor,
        shellSkinBackgroundColor,
      },
    },
    actions: { setSettings },
  } = useContext(SettingsContext);

  const [state, setState] = useState(CUSTOMIZATION_DEFAULT_DATA);

  useEffect(() => {
    setState({
      shellBgSkin: shellBgSkin,
      shellSkinLogo,
      shellSkinAccentColor,
      shellSkinAdditionalColor,
      shellSkinBackgroundColor,
    });
  }, [
    shellBgSkin,
    shellSkinLogo,
    shellSkinAccentColor,
    shellSkinAdditionalColor,
    shellSkinBackgroundColor,
  ]);

  const saveSettingsHandler = useCallback(() => {
    setSettings([
      {
        alias: ESettingsAliases.SHELL_SKIN_BACKGROUND_COLOR,
        value: state.shellSkinBackgroundColor,
      },
      {
        alias: ESettingsAliases.SHELL_SKIN_ACCENT_COLOR,
        value: state.shellSkinAccentColor,
      },
      {
        alias: ESettingsAliases.SHELL_SKIN_ADDITIONAL_COLOR,
        value: state.shellSkinAdditionalColor,
      },
      {
        alias: ESettingsAliases.SHELL_BG_SKIN,
        value: state.shellBgSkin,
      },
      {
        alias: ESettingsAliases.SHELL_SKIN_LOGO,
        value: state.shellSkinLogo,
      },
    ]).then(() => {
      notification.info({
        t,
        type: 'success',
        title: t('settings.success'),
        dismiss: 5,
      });
    });
  }, [state, setSettings]);

  return (
    <SettingsBlock title={t('settings.shell.customization.theme.title')}>
      <div className={s.container}>
        <div className={s.editor}>
          <ShellBackground
            bgColor={state.shellSkinBackgroundColor}
            bgImage={state.shellBgSkin || ''}
            setState={setState}
          />
          <CurrentColors
            additionalColor={state.shellSkinAdditionalColor}
            accentColor={state.shellSkinAccentColor}
            setState={setState}
          />
          <ShellIcon
            iconLink={state.shellSkinLogo}
            additionalColor={state.shellSkinAdditionalColor}
            setState={setState}
          />
        </div>
        <div className={s.preview}>
          <PreviewBlock state={state} save={saveSettingsHandler} />
        </div>
      </div>
    </SettingsBlock>
  );
};
